"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Customer_module_1 = require("./modules/Customer.module");
const Orders_module_1 = require("./modules/Orders.module");
const Session_module_1 = require("./modules/Session.module");
const loadReturnItemsModule = () => ({
    hasRouter: true,
    modules: [(0, Session_module_1.default)(), (0, Customer_module_1.default)(), (0, Orders_module_1.default)()],
});
exports.default = loadReturnItemsModule;
